import type { StaticImageData } from 'next/image';
import type { ReactNode } from 'react';

import { Box } from '@/components/Box';
import { Loader } from '@/components/Loader';

import * as S from './WatchProductAction.styles';

export interface WatchProductActionProps {
  altText?: string;
  buttonText: JSX.Element | string;
  icon?: ReactNode;
  imageSrc?: StaticImageData;
  isProcessing?: boolean;
  onClick: () => void;
}

export const WatchProductAction = ({
  altText,
  buttonText,
  icon,
  imageSrc,
  isProcessing,
  onClick,
}: WatchProductActionProps) => {
  if (isProcessing) {
    return (
      <Box data-test-id='WatchProductActionLoaderWrapper' padding={2}>
        <Loader
          data-test-id='WatchProductActionLoader'
          height='fullHeight'
          size='sm'
        />
      </Box>
    );
  }

  return (
    <S.AddButton onClick={onClick}>
      <S.Wrapper alignItems='center' gridGap='s100'>
        <S.PlusIcon />
        <S.ButtonText>{buttonText}</S.ButtonText>
        {icon}
      </S.Wrapper>
      {imageSrc && (
        <S.ButtonImageWrapper>
          <S.ButtonImage alt={altText ?? ''} fill sizes='10vw' src={imageSrc} />
        </S.ButtonImageWrapper>
      )}
    </S.AddButton>
  );
};
